export const DEFAULT_APPLICATION_STATUS = "Incomplete Application";

const isFilled = (value) => value != null && String(value).trim() !== "";

/** Fields expected for a complete client profile on an admission. */
export const CLIENT_PROFILE_FIELDS = [
  { key: "name", label: "Full name", section: "Personal" },
  { key: "dob", label: "Date of birth", section: "Personal" },
  { key: "gender", label: "Gender", section: "Personal" },
  { key: "maritalStatus", label: "Marital status", section: "Personal" },
  { key: "email", label: "Email", section: "Contact" },
  { key: "number", label: "Phone", section: "Contact" },
  { key: "address", label: "Address", section: "Contact" },
  { key: "passportNumber", label: "Passport number", section: "Identity & visa" },
  { key: "passportExpiry", label: "Passport expiry", section: "Identity & visa" },
  { key: "emergencyContactName", label: "Emergency contact name", section: "Emergency" },
  { key: "emergencyRelation", label: "Emergency relation", section: "Emergency" },
  { key: "emergencyContact", label: "Emergency phone", section: "Emergency" },
  { key: "emergencyEmail", label: "Emergency email", section: "Emergency" },
];

export function getClientProfileCompleteness(client) {
  console.log(client);
  if (!client) {
    return { isComplete: false, missing: CLIENT_PROFILE_FIELDS, missingBySection: {} };
  }

  const missing = CLIENT_PROFILE_FIELDS.filter((field) => !isFilled(client[field.key]));
  const missingBySection = missing.reduce((acc, field) => {
    if (!acc[field.section]) acc[field.section] = [];
    acc[field.section].push(field);
    return acc;
  }, {});

  return {
    isComplete: missing.length === 0,
    missing,
    missingBySection,
  };
}
